import firebase from 'firebase/app';
import 'firebase/database';

/**************** Firebase Configuration ********************
 * Developer: Stephen Fields
 * Creation Date: 9/27/2019
 * Modified Date: 9/27/2019
 * Comments: Configuration for Firebase database
*************************************************************/
const fireConfig = {
  apiKey: "AIzaSyBtOdDrFE6OyGHybDUUzXZRFkf-_WEKMY0",
  authDomain: "etsu-app.firebaseapp.com",
  databaseURL: "https://etsu-app.firebaseio.com",
  projectId: "etsu-app",
  storageBucket: "etsu-app.appspot.com",
  messagingSenderId: "908037285576",
  appId: "1:908037285576:web:2c4771a881e702d809a7fd"
}

firebase.initializeApp(fireConfig);

export default firebase;
